import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FiltersService } from 'app/components/filters/filters.service';
import { SearchService } from 'app/components/search/search.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { DetailsService } from 'app/components/details/details.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../login/login.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css']
})
export class FiltersComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  showFavorites: boolean = false;
  filterByFavorites: boolean = false;
  brandMode: boolean = false;
  eventData: object = {};
  @Input() filter;

  showFilters: boolean = false;

  countries: Array<any> = [];
  countriesSearch: Array<any> = [];
  sectors: Array<any> = [];
  ods: Array<any> = [];
  masterProperties: Array<any> = [];
  hierarchicalProperties: Array<any> = [];
  multiEvents: Array<any> = [];

  showHierarchicalProperties: boolean = false;
  showMasterProperties: boolean = false;
  showCountries: boolean = false;
  showSectors: boolean = false;
  showOds: boolean = false;
  showMultiEvents: boolean = false;
  showActiveFilters: boolean = false;
  searchConfig: object = {};
  selectedView: string;
  brandFilter:string = "";
  favoritesFilter:string = "";
  listCategoryParents: any[] = [];
  routeAcces = false;
  searchText: string = '';
  searchCountryText: string = '';
  activeCustomTranslate: boolean = false;
  categories: Array<any> = [];

  /** Subject que emite el texto de búsqueda cada vez que el usuario escribe */
  private searchSubject$: Subject<string> = new Subject<string>();
  /** Subject para destruir suscripciones al destruir el componente */
  private destroy$: Subject<void> = new Subject<void>();


  constructor(private sessionService: SessionService, public offcanvasService: NgbOffcanvas, public filtersService: FiltersService, private activatedRoute: ActivatedRoute,
  private searchService: SearchService, public utilsService: UtilsService, public detailsService: DetailsService, public translate: TranslateService,
  public loginService:LoginService, private analyticsService: AnalyticsService) { }

  /**
   * Emite el texto de búsqueda al Subject para que el pipeline con debounce lo procese.
   * @param event
   */
  handleSearchKeyUp(event) {
    this.searchSubject$.next(this.searchText);
  }

  /**
   * Configura el pipeline reactivo de búsqueda con debounce.
   * - debounceTime(500): espera 500ms tras la última tecla
   * - distinctUntilChanged: evita búsquedas duplicadas si el texto no cambió
   * - switchMap: cancela la petición HTTP anterior si llega una nueva
   */
  private initSearchPipeline(): void {
    this.searchSubject$.pipe(
      debounceTime(350),
      distinctUntilChanged(),
      switchMap((text: string) => {
        this.searchConfig = this.searchService.getSearchConfig();

        if (text.length >= 2) {
          this.searchConfig['searchText'] = text;
        } else {
          this.searchConfig['searchText'] = '';
        }

        this.searchService.setSearchConfig(this.searchConfig);
        this.analyticsService.sendSearch(this.searchConfig['searchText']);

        this.loader.count++;
        this.alertType = '';
        this.alertMessage = '';

        return this.searchService.unifiedSearch(this.searchConfig);
      }),
      takeUntil(this.destroy$)
    ).subscribe(
      (data: any) => {
        this.unifiedSearchOk(data);
      },
      (error) => {
        this.unifiedSearchError(error);
      }
    );
  }

    unifiedSearch(unifiedSearchIn) {

      this.loader.count++;
      this.alertType = '';
      this.alertMessage = '';

      this.searchService.unifiedSearch(unifiedSearchIn)
        .subscribe((data: object) => {
          this.unifiedSearchOk(data);
        },
          error => {
            this.unifiedSearchError(error);
          });

    }

    unifiedSearchOk(data) {
      this.loader.count--;
      this.searchService.setResetList(true);
      this.searchService.setItemsObs(data.list);
      this.searchService.setNumItemsObs(data.numElements);
      this.analyticsService.sendViewItemList(data.list, this.searchConfig['filter'] === 'ONLY_EXHIBITORS' ? 'exhibitor' : 'product', this.selectedView);
    }

    unifiedSearchError(error) {

      let alertData = {
        alertType: 'error',
        alertMessage: error.message
      }

      this.loader.count--;
      this.alertType = alertData.alertType;
      this.alertMessage = alertData.alertMessage;

    }

  handleSearch(){}

  handleFavoriteSearch(){}

  filterIsActive(){
    this.searchConfig = this.searchService.getSearchConfig();
    if (this.searchConfig['selectedCountries'].length > 0 || this.searchConfig['selectedHierarchicalProperties'].length > 0 || this.searchConfig['selectedHomeOds'].length > 0
      || this.searchConfig['selectedMultiEvents'].length > 0 || this.searchConfig['selectedProperties'].length > 0 || this.searchConfig['selectedSectors'].length > 0) {
      return true;
    } else {
      return false;
    }
  }

  toggleFilters(){
    this.showFilters = !this.showFilters;
  }

  getFiltersBackground(){}
  
  setSelectedView(view) {
    this.filtersService.setSelectedView(view);
  }


  /** Logic to make background semi transparent */
  getTabBackground(tabName) {
    let mainColor = this.eventData['mainColor'];
    return this.selectedView === tabName ? (this.utilsService.isEmptyOrUndefined(mainColor) ? "transparent" : this.addAlpha(mainColor, 0.15) ) : "transparent";
  }

  hexToRgb = function(hex:string):Array<number>{
    const theHex:string = (hex.substring(0,1) === '#') ? hex.substr(1) : hex;
    const red:number = parseInt(theHex.substring(0,2), 16);
    const green:number = parseInt(theHex.substring(2,4), 16);
    const blue:number = parseInt(theHex.substring(4,6), 16);
    return [red, green, blue];
  }

  addAlpha(color:string, alpha:number):string {
    const baseColor:Array<number> = this.hexToRgb(color);
    const goodAlpha:number = alpha ? typeof(alpha) === 'number' ? ((alpha <= 1 && alpha >= 0) ? alpha : 0 ): 0 : 0;
    return `rgba(${baseColor[0]},${baseColor[1]},${baseColor[2]},${goodAlpha})`;
  }

  getCountries(getCountriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getCountries(getCountriesIn)
      .subscribe((data: object) => {
        this.getCountriesOk(data);
      },
        error => {
          this.getCountriesError(error);
        });

  }

  getCountriesOk(data) {
    this.loader.count--;
    this.countries = data?._embedded?.countries;
    this.countriesSearch = this.countries;
    this.searchConfig = this.searchService.getSearchConfig();
    this.updatePropertiesFromSession(this.searchConfig['selectedCountries'], this.countries, 'countries');
  }

  getCountriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getSectors(getSectorsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getSectors(getSectorsIn)
      .subscribe((data: object) => {
        this.getSectorsOk(data);
      },
        error => {
          this.getSectorsError(error);
        });

  }

  getSectorsOk(data) {

    this.loader.count--;
    this.sectors = data._embedded.sectors;
    this.searchConfig = this.searchService.getSearchConfig();
    this.updatePropertiesFromSession(this.searchConfig['selectedSectors'], this.sectors, 'sectors');
    if (!this.utilsService.isEmptyObject(this.sectors))
      this.sessionService.set(`${this.eventData['sapCode']}.selectedSectors`, this.sectors);

  }

  getSectorsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getOds(getOdsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getOds(getOdsIn)
      .subscribe((data: object) => {
        this.getOdsOk(data);
      },
        error => {
          this.getOdsError(error);
        });

  }

  getOdsOk(data) {
    this.loader.count--;
    this.ods = data;
    this.searchConfig = this.searchService.getSearchConfig();
    this.updatePropertiesFromSession(this.searchConfig['selectedHomeOds'], this.ods, 'ods');
  }

  getOdsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getMasterProperties(getMasterPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getMasterProperties(getMasterPropertiesIn)
      .subscribe((data: object) => {
        this.getMasterPropertiesOk(data);
      },
        error => {
          this.getMasterPropertiesError(error);
        });

  }

  getMasterPropertiesOk(data) {

    this.loader.count--;
    this.masterProperties = data;
    this.searchConfig = this.searchService.getSearchConfig();
    this.updatePropertiesFromSession(this.searchConfig['selectedProperties'], this.masterProperties, 'master');

  }

  getMasterPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {

    this.loader.count--;
    this.hierarchicalProperties = data;
    this.searchConfig = this.searchService.getSearchConfig();
    if(this.filter === 'ONLY_EXHIBITORS')
      this.hierarchicalProperties = this.hierarchicalProperties.filter(cS => cS.categoryScopeId !== 3);
    if (!this.utilsService.isEmptyObject(this.hierarchicalProperties))
      this.sessionService.set(`${this.eventData['sapCode']}.selectedHierarchicalProperties`, this.hierarchicalProperties);
    this.updatePropertiesFromSession(this.searchConfig['selectedHierarchicalProperties'], this.hierarchicalProperties, 'hierarchical');
    //this.updatePropertiesFromSession(this.utilsService.isEmptyOrUndefined(this.searchConfig['selectedHierarchicalProperties'])? data[0].id: this.searchConfig['selectedHierarchicalProperties'], this.hierarchicalProperties, 'hierarchical');
    this.getShowCategories(data);
  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getMultiEvents(getMultiEventsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getMultiEvents(getMultiEventsIn)
      .subscribe((data: object) => {
        this.getMultiEventsOk(data);
      },
        error => {
          this.getMultiEventsError(error);
        });

  }

  getMultiEventsOk(data) {
    this.loader.count--;
    this.multiEvents = data;

    this.multiEvents.push({
      id: this.eventData['id'],
      sapCode: this.eventData['sapCode'],
      salon: this.eventData['salon'],
      edition: this.eventData['edition'],
      label: this.eventData['label'],
    });
    
    if (!this.utilsService.isEmptyObject(this.multiEvents))
      this.sessionService.set(`${this.eventData['sapCode']}.subCatalogues`, this.multiEvents);
  }

  getMultiEventsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  updatePropertiesFromSession(itemsId, items, type) {

    let childsPropertyName = 'properties';

    if (type === 'hierarchical') {
      childsPropertyName = 'childHierarchicalProperties';
    }

    if(items){
      for (let i = 0; i < items.length; i++) {

        if (itemsId.includes(items[i].id)) {
  
          items[i].checked = true;
  
          type = type || 'Hierarchical';
          let valueKey = 'id';
          let propertyName = this.utilsService.setPropertyName(type);
  
          this.searchService.addItemToProperty(propertyName, items[i][valueKey], items[i]);
  
        }
  
        items[i][childsPropertyName] = items[i][childsPropertyName] || [];
  
        if (items[i][childsPropertyName].length > 0) {
          this.updatePropertiesFromSession(itemsId, items[i][childsPropertyName], type);
        }
  
      }
    }
  }

  getShowCategories(list){
    if (list && list.length > 0) {
      list.filter(
        category => {
          if (category.showProperty === true) {
            if (category.childHierarchicalProperties.length > 0) {
              this.getShowCategories(category.childHierarchicalProperties);
            } else {
              this.categories.push(category);
              this.sessionService.set(`${this.eventData['sapCode']}.categories`, this.categories);
            }
          } else {
            if (category.childHierarchicalProperties.length > 0) {
              this.getShowCategories(category.childHierarchicalProperties);
            }
          }
        }
      );
    }
  }

  uploadCategoryParent(){

    this.hierarchicalProperties.forEach(element => {
      this.listCategoryParents.push(element);
    });


    this.hierarchicalProperties.forEach(element => {
      this.getAllDescendantNodes(element).forEach(child => {
        this.listCategoryParents.push(child);
      })
    });

  }

  getAllDescendantNodes(parentNode): Array<any> {
    let nodes:Array<any> = [];
      if (parentNode.childHierarchicalProperties.length > 0) {
        parentNode.childHierarchicalProperties.forEach(childNode => {
          nodes.push(childNode);
          if (childNode.childHierarchicalProperties.length > 0) {
            nodes = nodes.concat(this.getAllDescendantNodes(childNode));
          }
        });
      }
    return nodes;
  }


  /*
  createChildsParents(){

    this.searchConfig.selectedCountries = info.data;
    this.storage.session(`${this.eventData.sapCode}.searchConfig`, this.searchConfig);
    this.countFilters();
    this.handleSearch();
    this.broadcaster.broadcast('filterAppliedCountries', info.data);
    
    this.isArray = Array.isArray(this.searchConfig.selectedCountries);

    if (this.type === 'Hierarchical') {
      this.childsPropertyName = 'childHierarchicalProperties';
    } else {
      this.childsPropertyName = 'properties';
    }

    this.items[this.childsPropertyName] = this.items[this.childsPropertyName] || [];

    if (this.items[this.childsPropertyName].length > 0) {
      this.isFather = true;
    } else if (this.type !== 'Ods') {
      this.isFather = false;
    }

    if (this.isFather) {
      this.items['opened'] = false;
    } else {
      this.items['checked'] = this.items['checked'] || false;
    }

    
  }
  */

  
 
  updateFilter(elem) {

    let item = elem.item;
    let type = elem.type;

    type = type;
    let valueKey = 'id';
    let propertyName = this.utilsService.setPropertyName(type);;

    if (item['checked']) {
      this.searchService.addItemToProperty(propertyName, item[valueKey], item);
      this.analyticsService.sendFilters('add', propertyName, item.translations, item[valueKey]);
    } else {
      this.searchService.removeItemFromProperty(propertyName, item[valueKey], item);
      this.analyticsService.sendFilters('remove', propertyName, item.translations, item[valueKey]);
    }

    let unifiedSearchIn = this.searchService.getSearchConfig();

    this.unifiedSearch(unifiedSearchIn);

  }

  updateFavorites(){

    this.showFavorites = !this.showFavorites;
    this.filterByFavorites = !this.filterByFavorites;

  }

  handleSearchCountryKeyUp(event) {
    this.countries = this.countriesSearch.filter(obj => {
      return this.utilsService._api(obj['translations'], 'translation').toLowerCase().includes(this.searchCountryText.toLowerCase());
    });
  }

  
  onKeyUp(ev) {

    this.filtersService.setKeyBrands(this.brandFilter);

  }

  handleFavoriteSearchKeyUp(ev) {

    this.filtersService.setKeyFavorite(this.favoritesFilter);

  }

  ngOnInit() {

    // Inicializar el pipeline de búsqueda con debounce
    this.initSearchPipeline();

    this.activeCustomTranslate = this.utilsService.existCustomTranslate();

    this.brandMode = (this.filter === 'ONLY_BRANDS');

    this.searchConfig = this.searchService.getSearchConfig();

    this.searchText = this.searchConfig['searchText'];
    
    this.activatedRoute.queryParams.subscribe(params  => {
      const tab = params['tab'];
      this.routeAcces = params['filter'];
      this.showFavorites = this.filterByFavorites = tab === 'favorites';
    });

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let eventName = JSON.parse(this.sessionService.get('eventName', false));
    let eventId = JSON.parse(this.sessionService.get('catalogId', false));
    let sapCode = this.eventData['sapCode'];
    this.showHierarchicalProperties = this.utilsService.isEmptyOrUndefined(JSON.parse(this.sessionService.get(sapCode + '.selectedHierarchicalProperties', true)));

    if (this.filter !== 'ONLY_BRANDS' && this.filter !== 'ONLY_MAPS') {

      let getCountriesIn = {
        catalogueId: eventId
      };

      this.getCountries(getCountriesIn);

      let getSectorsIn = {
        eventName: eventName
      };

      this.getSectors(getSectorsIn);

      let getOdsIn = {
        eventName: eventName
      };

      this.getOds(getOdsIn);

      let getMasterPropertiesIn = {
        eventName: eventName
      };

      this.getMasterProperties(getMasterPropertiesIn);

      let getHierarchicalPropertiesIn = {
        eventName: eventName
      };

      this.getHierarchicalProperties(getHierarchicalPropertiesIn);

      let getMultiEventsIn = {
        catalogueId: eventId
      };

      this.getMultiEvents(getMultiEventsIn);

    }

    this.filtersService.getSelectedView().subscribe(data => {
      this.selectedView = data;
    });

  }

  ngOnDestroy(): void {
    // Completar el Subject para cancelar todas las suscripciones pendientes
    this.destroy$.next();
    this.destroy$.complete();
  }

}
